import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CompanyService } from '../../services/company.service';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-verify-otp',
  imports: [FormsModule, NgxSpinnerModule, ReactiveFormsModule, CommonModule],
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.css'
})
export class VerifyOtpComponent implements OnInit, AfterViewInit  {

  email: string = '';
  otp: string = '';
  otpForm!: FormGroup;
  error?: string | null;
  @ViewChild('otpInput') otpInput!: ElementRef;

  constructor(
    private route: ActivatedRoute,   
    private companyService: CompanyService,
    private router: Router,
    private ngx: NgxSpinnerService,   
     private fb: FormBuilder,
     private headerService: HeaderService,
  ) {}

  ngOnInit(): void {      
    this.email = sessionStorage.getItem('username') || '';
    this.buildForm();
  }

  ngAfterViewInit(): void {
    this.otpInput.nativeElement.focus();
  }

   buildForm(): void {
    this.otpForm = this.fb.group({
   otpCode: ['', [Validators.required, Validators.minLength(6),
      Validators.maxLength(6)]]
    });
   }

 verifyOtp(): void {
  this.otpForm.markAllAsTouched();
  if (this.otpForm.invalid) {
    return;
  }
  else
  {
    this.ngx.show();
    this.otp = this.otpForm.get('otpCode')?.value;
    
    const payload = {
    email: this.email,
    otpCode: this.otp
    }
    
    this.companyService.verifyEmailOtp(payload).subscribe({
      next: res => {
          sessionStorage.setItem('companyId', res.companyId);
          sessionStorage.setItem('email', res.userEmail);
          sessionStorage.setItem('roleCode', res.roleCode);
          sessionStorage.setItem('companyName', res.companyName);
          if (res.roleCode == 1) {
            sessionStorage.setItem('superAdminCompanyId', res.companyId);
          }
          this.headerService.setCompanyName(res.companyName);
          localStorage.setItem('token', res.token)
          this.ngx.hide();
           const returnUrl =
    this.route.snapshot.queryParamMap.get('returnUrl')
    || '/home';

    this.router.navigateByUrl(returnUrl);          
        },
      error: (err) => {       
        this.error = err.error;             
        this.ngx.hide();       
      }
    });
  }

  }

   backClick(): void {
    this.router.navigate(['/login']); 
  }

  onInput(event: any, controlName: string) {
  this.error = null;
  const input = event.target;

  // Keep digits only
  let value = input.value.replace(/\D/g, '');

  // Limit to 6 digits
  value = value.slice(0, 6);

  input.value = value;
  this.otpForm.get(controlName)?.setValue(value, { emitEvent: false });
}
}
